import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import ObjectForm from '../../components/ObjectForm'

import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
const WarehouseCreate = ({open, close, model, ...rest}) => {
    const app = React.useContext(AppContext)
    const { recall, setRecall } = app
    const { cities, states, countries } = app.address
    const { create, update, } = app.warehouses
    
    const submit = model?update:create
    const title = model?"Actualizar":"Añadir"
    const city = model? cities.find(c => c.id == model.address? false: model.address.street.city.id) : ''
    const state = model? states.find(s => s.id == model.address? false: model.address.street.city.state.id) : ''
    const country = model? countries.find(c => c.id == model.address? false: model.address.street.city.state.country.id) : ''

    const [selectedCountry, setSelectedCountry] = React.useState(city)
    const [selectedState, setSelectedState] = React.useState(state)
    const [selectedCity, setSelectedCity] = React.useState(country)

    const handleSubmit = (warehouse) => {
        warehouse["country"]= selectedCountry
        warehouse["state"]= selectedState
        warehouse["city"]= selectedCity
        submit(warehouse)
    }

    return (
        <Dialog onClose={close} open={open}>
        <DialogTitle>{title} Almacén</DialogTitle>
        <ObjectForm ignored={['id']} recall={recall} submit={handleSubmit}
            obj={{name:'', street:'', exterior:'', interior:'', postal_code:'', city:selectedCity, state:selectedState, country:selectedCountry, }}
            disabled={{city:!selectedState, state:!selectedCountry }}
            labels={{name:'Nombre', street: 'Calle', exterior: 'Exterior', interior: 'Interior', postal_code: 'Código Postal', city:'Ciudad', state:'Estado', country:'País', }}
            types={{name:'text', street: 'text', exterior: 'text', interior: 'text', postal_code: 'text', city:'select-controlled', state:'select-controlled', country:'select-controlled', }}
            options={{
                country: countries.map(c => ({value:c.id, label: c.name}) ),
                city: cities.filter(c => c.stateId == selectedState).map(c => ({value:c.id, label:c.name}) ), 
                state: states.filter(s => s.countryId == selectedCountry).map(s => ({value:s.id, label: s.name}) ),
            }}
            controlled={{
                country: (c) => {
                    setSelectedCountry(c)
                },
                state: (s) => {
                    setSelectedState(s)
                },
                city: (c) => {
                    setSelectedCity(c)  
                },
            }}
            changed={model?{
                    ...model, 
                    city:city?city.id:null,
                    state:state?state.id:null,
                    country:country?country.id:null,
            }: {}} 
        />
        <Button onClick={() => {setRecall(true);close()}}>{title}</Button>
        </Dialog>
        )
    }
    export default WarehouseCreate